<template>
  <video
    ref="videoPlayer"
    class="video-js"
    width="100%"
    height="100%"
    controls
  >
    <source
      :src="src"
      type="video/mp4"
    >
    <p class="vjs-no-js">
      To view this video please enable JavaScript
    </p>
  </video>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  name: 'VideoPlayer',
  props: {
    src: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      player: null,
      defaultOptions: {
        autoplay: false,
        controls: true,
        preload: false,
        poster: `${window.location.origin}/img/unleash.jpg`
      }
    }
  },

  mounted () {
    this.player = videojs(
      this.$refs.videoPlayer,
      Object.assign(this.defaultOptions, this.options)
    )
  },

  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
